<template>
  <div>
  <!-- navigation -->
 <Navigation> </Navigation>
  <!-- navigation -->


<section style="background-color:#001969" class="text-center pt-2 pb-2">
<div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
    <h3 class="display-4 text-white">
                        Training
    </h3>
    <h6 class="text-white text-lg">This is some dummy text. This is some dummy text. This is some dummy text. This is some dummy text. This is some dummy text. </h6>
    </div>
    </section>
<section>
<div class="container">
            <div class="row">
                <div class="col-lg-6 col-md-6 pt-5">
                    <h3 class="mt-5">
                        Some dummy text
                    </h3>

                    <br>
                    <span>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has
                        been the industry's standard dummy text ever since the 1500s.</span>
                </div>

                <div class="col-lg-6 col-md-6">
                <div class="">
                        <img v-bind:src="'../imgs/img_training.png'" class="dashboard-image img-fluid m-2" alt="">
                </div>
                   
                   <div >
                 </div>
                   
                </div>
            </div>
        </div>
</section>
<br>
<br>
<section>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="grid grid-cols-2 gap-2">
            <div class="">
                        <img v-bind:src="'../imgs/img_training_bulb.png'" class="img-fluid" style="display:block; margin:auto;" width="400" height="400" alt="">
            </div>
            <div>
                <br>
                        <span class="text-sm text-slate-400">What you gain</span>
                        <h4 style="#001969" class="text-2xl">Some Text Heading Here</h4>
                        <ul style="list-style-type:disc">
                            <li class="font-weight-bold">
                                Some dummy description here
                            </li>
                            <li class="font-weight-bold">
                                Some dummy description here
                            </li>
                            <li class="font-weight-bold">
                                Some dummy description here
                            </li>
                            <li class="font-weight-bold">
                                Some dummy description here
                            </li>
                        </ul>

            </div>
        </div>
    </div>
</section>
<br>
<section>
    <h2 class="text-center features-heading mt-5">Technologies</h2>
    <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="grid grid-cols-3 gap-2">
            <div class="rounded-lg p-3" style="background-color:#00CCC1">
                <span class="text-lg text-white font-weight-bold">Some Technology</span>
                <p>Some Technologies are new to the market, this is a dummy text.</p>


            </div>

            <div class="rounded-lg p-3" style="background-color:#00CCC1">
                <span class="text-lg text-white font-weight-bold">Some Technology</span>
                <p>Some Technologies are new to the market, this is a dummy text.</p>


            </div>

            <div class="rounded-lg p-3" style="background-color:#00CCC1">
                <span class="text-lg text-white font-weight-bold">Some Technology</span>
                <p>Some Technologies are new to the market, this is a dummy text.</p>


            </div>
            
            <div class="rounded-lg p-3" style="background-color:#00CCC1">
                <span class="text-lg text-white font-weight-bold">Some Technology</span>
                <p>Some Technologies are new to the market, this is a dummy text.</p>


            </div>
            
            <div class="rounded-lg p-3" style="background-color:#00CCC1">
                <span class="text-lg text-white font-weight-bold">Some Technology</span>
                <p>Some Technologies are new to the market, this is a dummy text.</p>


            </div>
            
            <div class="rounded-lg p-3" style="background-color:#00CCC1">
                <span class="text-lg text-white font-weight-bold">Some Technology</span>
                <p>Some Technologies are new to the market, this is a dummy text.</p>


            </div>
            
        </div>
    </div>

    
</section>

      <!-- FAQ section - START -->
    
    <section id="faq">
        <div class="container">

            <h2 class="text-center features-heading mt-5">Frequently Asked Questions</h2>

            <!-- <div class="faq-header">Frequently Asked Questions</div> -->

            <div class="faq-content">
                <div class="faq-question">
                    <input id="q1" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q1" class="panel-title">What is the meaning of manage?</label>
                    <div class="panel-content">42</div>
                </div>

                <div class="faq-question">
                    <input id="q2" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q2" class="panel-title">How much wood would a woodchuck chuck?</label>
                    <div class="panel-content">A woodchuck would chuck all the wood he could chuck, if a woodchuck could
                        chuck wood!</div>
                </div>

                <div class="faq-question">
                    <input id="q3" type="checkbox" class="panel">
                    <div class="plus">+</div>
                    <label for="q3" class="panel-title">What happens if Pinocchio says, "my nose will grow now"?</label>
                    <div class="panel-content">Certain questions are better left &nbsp; <a
                            href="https://en.wikipedia.org/wiki/The_Unanswered_Question" target="_blank">unanswered</a>
                    </div>
                </div>
            </div>

        </div>
    </section>

    <!-- FAQ section - END -->




  </div>
</template>

<script>

    import { Head, Link } from '@inertiajs/inertia-vue3';
    import Navigation from "@/Layouts/Navigation.vue";
    import AppLayout from "@/Layouts/AppLayout.vue";
      import JetNavLink from '@/Jetstream/NavLink.vue'
export default {
 props: {
            canLogin: Boolean,
            canRegister: Boolean,
        },
        components: {
            AppLayout,
            Navigation,
            JetNavLink,
        },
         data() {
        return {
            //url: '/' 
        }
    }
    
}
</script>

<style>
.img_size{


    height:auto;
    width:155px;
}
:root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }

    * {
        outline: none;
    }

    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }

    /*Scroll - END*/

        .faq-header {
        font-size: 42px;
        border-bottom: 1px dotted #ccc;
        padding: 24px;
    }

    .faq-content {
        margin: 0 auto;
    }

    .faq-question {
        padding: 20px 0;
        border-bottom: 1px dotted #ccc;
    }

    .panel-title {
        font-size: 18px;
        width: 100%;
        position: relative;
        margin: 0;
        padding: 10px 10px 0 48px;
        display: block;
        cursor: pointer;
    }

    .panel-content {
        font-size: 20px;
        padding: 0px 14px;
        margin: 0 40px;
        height: 0;
        overflow: hidden;
        z-index: -1;
        position: relative;
        opacity: 0;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.panel-content {
        height: auto;
        opacity: 1;
        padding: 14px;
    }

    .plus {
        position: absolute;
        margin-left: 20px;
        margin-top: 13px;
        z-index: 5;
        font-size: 20px;
        line-height: 100%;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        -o-user-select: none;
        user-select: none;
        -webkit-transition: .2s ease;
        -moz-transition: .2s ease;
        -o-transition: .2s ease;
        transition: .2s ease;
    }

    .panel:checked~.plus {
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        transform: rotate(45deg);
    }

    .panel {
        display: none;
    }

    	.mobile-section-h3{
    	color: #333;
		font-weight: 600;
    }
    </style>
